/**
 * Case Types
 * Types for legal case management
 * Matches backend Case model and schemas
 */

export interface Case {
  id: string  // UUID
  case_type?: number | null
  title?: string | null
  case_number?: string | null
  place_of_detention?: string | null
  court_pending?: string | null
  status?: string | null  // e.g. "pending", "ongoing", "resolved"
  court_code?: string | null
  nature?: string | null
  action_taken?: string | null
  adverse?: Record<string, any> | null  // JSONB
  other_details?: Record<string, any> | null  // JSONB
  user_id?: string | null  // Assigned lawyer UUID
  visit_transaction_id?: string | null  // UUID

  // Lawyer information (joined from users + user_profile)
  lawyer_username?: string | null
  lawyer_firstname?: string | null
  lawyer_lastname?: string | null

  // Visit this case originated from (joined via visit_transaction_id)
  visit_id?: string | null
}

export interface CaseUpdate {
  case_type?: number | null
  title?: string | null
  case_number?: string | null
  place_of_detention?: string | null
  court_pending?: string | null
  status?: string | null
  court_code?: string | null
  nature?: string | null
  action_taken?: string | null
  adverse?: Record<string, any> | null
  other_details?: Record<string, any> | null
  user_id?: string | null
  visit_transaction_id?: string | null
}

export interface CaseListItem {
  id: string
  case_number?: string | null
  title?: string | null
  nature?: string | null
  status?: string | null
  court_pending?: string | null
  court_code?: string | null
  user_id?: string | null
  // Lawyer information
  lawyer_username?: string | null
  lawyer_firstname?: string | null
  lawyer_lastname?: string | null
}

export interface Lawyer {
  userid: string
  fullname: string
}

export interface CasePaginatedResponse {
  items: CaseListItem[]
  total: number
  page: number
  limit: number
  pages: number
}

export interface CaseFilters {
  search?: string
  status?: string
  case_type?: number
  user_id?: string
  court_pending?: string
}

// Case status labels and colors (status is stored as string in DB)
export const CASE_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  ongoing: 'In Progress',
  resolved: 'Resolved',
  dismissed: 'Dismissed',
  archived: 'Archived',
}

export const CASE_STATUS_COLORS: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-800',
  ongoing: 'bg-blue-100 text-blue-800',
  resolved: 'bg-green-100 text-green-800',
  dismissed: 'bg-red-100 text-red-800',
  archived: 'bg-gray-100 text-gray-800',
}
